function ROIIcon(props) {
  return (
    <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#prefix__clip0_1288_1431)" fill="#000">
        <path d="M9.584 22.416c-1.869-1.869-2.727-4.363-2.615-6.817h2.226l-3.403-4.136L2.39 15.6h2.302c-.113 3.032.97 6.103 3.288 8.421 4.162 4.163 10.747 4.411 15.198.762l-1.62-1.62c-3.553 2.767-8.71 2.518-11.974-.746zM24.02 7.98c-4.162-4.162-10.747-4.411-15.198-.762l1.62 1.62c3.553-2.767 8.71-2.518 11.974.746 1.869 1.869 2.727 4.363 2.615 6.817h-2.226l3.403 3.752L29.61 16.4h-2.302c.113-3.032-.97-6.103-3.288-8.421z" />
        <path d="M17.043 15.147v-2.305c.591.126 1.058.41 1.432.821l.311.348L20 12.81l-.342-.348c-.685-.695-1.588-1.105-2.646-1.263V10h-1.588v1.2c-1.743.221-2.926 1.295-2.926 2.684 0 1.769 1.588 2.305 2.926 2.653v2.652a3.648 3.648 0 01-1.899-1.01l-.342-.347L12 19.063l.311.316c.747.79 1.837 1.326 3.082 1.453V22h1.587v-1.168c2.21-.285 2.989-1.61 2.989-2.843.062-1.894-1.681-2.526-2.926-2.842zm0 4.042v-2.242c.871.285 1.214.6 1.214 1.106 0 .22-.094.915-1.214 1.136zm-1.588-6.379v1.895c-.81-.252-1.12-.505-1.12-.884 0-.442.435-.853 1.12-1.01z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_1288_1431">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ROIIcon
